import "./education.css"
import stars from "../../images/stars.svg"
import arrow from "../../images/arrow-2.svg"
import edu from "../../images/education.svg"
import "./education.css"

export default function Education() {
    const data = [
        { title: 'Class X in SSC', subtitle: 'KD Ambani Reliance Foundation School', year: 'Apr 2017 - Mar 2018' },
        { title: 'Class XII in HSC', subtitle: 'KD Ambani Reliance Foundation School', year: 'Mar 2019 - Mar 2020' },
        { title: 'B.Tech in Computer Science & Engineering', subtitle: 'Institute of Technology, Nirma University', year: 'Oct 2020 - May 2024' }
    ]

    const dataComponent = data.map((x, idx) => (
        <div className="education-card" key={idx}>
            <h4>{x.title}</h4>
            <p>{x.subtitle}</p>
            <p>{x.year}</p>
        </div>
    ))

    return (
        <div className="education">
            <header className="education-header">
                <h2>My Education</h2>
                <img src={stars} alt="stars" />
            </header>
            <section className="education-arrow">
                <img className="education-arrow-img" src={arrow} alt="arrow" />
                <p className="education-arrow-text">In my 11th grade, I embarked on my programming journey with Python as my very first language.</p>
            </section>
            <section className="education-main">
                <img src={edu} alt="school and university pictures" />
                <div>
                    {dataComponent}
                </div>
            </section>
        </div>
    )
}